import React from "react";
import { Label } from "react-bootstrap";
import { components } from "react-select";

export const SelectFieldOption = (props) => {
  return (
    <>
      <components.Option {...props}>
        <span>
          {props.data.cubeLabel && (
            <React.Fragment>
              {props.data.cubeLabel}
              {" "}
              <span className="object-type label label-success">Cube</span>
              {" - "}
            </React.Fragment>
          )}
          {props.data.label}
          {" "}
          <span className="object-type label label-success">Variable</span>
          {" "} 
          {!props.data.isImplemented && (
            <Label
            className={"object-implementation"}
            bsStyle="info"
          >
            LOGICAL
          </Label>
          )}
        </span>
      </components.Option>
    </>
  );
}

